export const darkBorderParticipationFrame = () => ({
  id: 'dark-border-participation-frame',
  name: 'Dark Border Participation Frame',
  thumbnail: '/assets/diploma-templates/05_frame.webp',
  data: {
    elements: [],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/05_background.svg',
      key: null
    }
  }
});
